class SearchDrawer extends HTMLElement {
  connectedCallback() {
    // Move to body on first connection so we escape any parent stacking context
    // (section-header-group has z-index: 3 + sticky which traps fixed children).
    if (this.parentElement !== document.body && !this._moved) {
      this._moved = true;
      document.body.appendChild(this);
      return; // connectedCallback will fire again after re-append
    }
    if (this._initialised) return;
    this._initialised = true;

    this.panel = this.querySelector('.search-drawer__panel');
    this.input = this.querySelector('.search-drawer__input');
    this.defaultContent = this.querySelector('#SearchDrawerDefault');
    this.closeBtn = this.querySelector('.search-drawer__close');
    this.clearBtn = this.querySelector('.search-drawer__clear');

    this.querySelector('#SearchDrawer-Overlay')?.addEventListener('click', () => this.close());
    this.closeBtn?.addEventListener('click', () => this.close());

    document.addEventListener('keyup', (e) => {
      if (e.code === 'Escape' && this.classList.contains('active')) this.close();
    });

    if (this.input) {
      this.input.addEventListener('input', () => this.syncUI());
    }

    // When form resets (clear button or programmatic), sync UI
    this.querySelector('form')?.addEventListener('reset', () => {
      setTimeout(() => this.syncUI(), 0);
    });

    if (this.clearBtn) {
      this.clearBtn.addEventListener('click', (e) => {
        e.preventDefault();
        this.querySelector('form')?.reset();
        this.input?.focus();
      });
    }
  }

  syncUI() {
    const hasValue = (this.input?.value || '').trim().length > 0;
    this.defaultContent?.classList.toggle('hidden', hasValue);
    this.clearBtn?.classList.toggle('hidden', !hasValue);
  }

  open(triggeredBy) {
    this.activeElement = triggeredBy || document.activeElement;
    this.style.visibility = '';
    document.body.classList.add('overflow-hidden');
    // Tiny delay ensures CSS transition fires
    requestAnimationFrame(() => {
      requestAnimationFrame(() => this.classList.add('active'));
    });
    this.addEventListener('transitionend', () => this.input?.focus(), { once: true });
  }

  close() {
    this.classList.remove('active');
    document.body.classList.remove('overflow-hidden');
    setTimeout(() => this.activeElement?.focus(), 50);
  }
}

customElements.define('search-drawer', SearchDrawer);

// Use event delegation so this works even if the header rerenders (theme editor)
document.addEventListener('click', (e) => {
  if (e.target.closest('.header__icon--search')) {
    e.preventDefault();
    document.querySelector('search-drawer')?.open(e.target.closest('.header__icon--search'));
  }
});
